module.exports = __webpack_public_path__ + "img/Pika.689cb6d0.png";